import { ResetPasswordPage } from "@/features/auth/pages/ResetPasswordPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/reset-password/$token")({
	component: function ResetPasswordRoute() {
		const { token } = Route.useParams();
		return <ResetPasswordPage token={token} />;
	},
});
